/*
 * Pre-order confirmation before checkout (snippets/jc-preorder-confirm.liquid).
 * When the cart page or cart drawer shows the pre-order notice (snippets/jc-preorder-cart-note),
 * pressing its checkout button first opens a dialog listing the pre-order items and their shipping
 * time; "Got it" continues to checkout with the same button. Express checkout buttons stay untouched.
 */
(function () {
  var dialog = document.querySelector('[data-jc-pre-confirm]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var list = dialog.querySelector('[data-jc-pre-confirm-list]');
  var pendingButton = null;
  var confirmed = false;

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('button[name="checkout"]');
      if (!button || confirmed) return;
      var root = button.closest('cart-drawer') || document.getElementById('main-cart-footer') || document;
      var note = root.querySelector('[data-jc-preorder-note]');
      if (!note) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      list.replaceChildren.apply(
        list,
        Array.prototype.map.call(note.querySelectorAll('.jc-pre-note__item'), function (item) {
          return item.cloneNode(true);
        })
      );
      pendingButton = button;
      dialog.showModal();
      dialog.querySelector('[data-jc-pre-confirm-ok]').focus();
    },
    true
  );

  dialog.querySelector('[data-jc-pre-confirm-ok]').addEventListener('click', function () {
    confirmed = true;
    dialog.close();
    if (pendingButton) pendingButton.click();
  });

  dialog.querySelector('[data-jc-pre-confirm-back]').addEventListener('click', function () {
    dialog.close();
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
})();
